<template>
  <Block type="accountSetting" id="profile" class="pd20">
    <common-header
      is-passport
      :show-back="!isSDK"
      :show-lang="!isSDK"
      :title="accountLanguages.profile"
    ></common-header>
    <ProfileHeader
      :languages="accountLanguages"
      :completionLeft="completionLeft"
      :completion="completion"
    ></ProfileHeader>
    <form id="changePasswordForm" :class="$platformClass" v-if="!isVgm">
      <Editor
        v-model="realName"
        editorClass="editor"
        class="editor-wrapper relative"
        type="passportAccountEditor"
        :disable="disableRealName"
        :placeholder="accountLanguages.realName"
      ></Editor>
      <Block type="editorWrapper" class="editor-wrapper">
        <div class="editor relative">
          <span class="common-title">{{ accountLanguages.gender }}</span>
          <div class="sex-box" id="J_sex_box">
            <i
              class="sex-icon splite"
              v-bind:class="{ male: sex == MALE, female: sex == FEMALE }"
            ></i>
            <button
              type="button"
              :disabled="disableSex"
              @click="switchSex"
              class="sex_radios splite"
            ></button>
            <div class="sex-box-text" id="J_sex_box_text">{{ sexText }}</div>
          </div>
        </div>
      </Block>
      <Block type="editorWrapper" class="editor-wrapper">
        <div class="editor relative div-label">
          <span class="common-title span-label">
            {{ accountLanguages.birthday }}
          </span>
          <input
            class="date-editor"
            v-if="!disableBirthday"
            :disabled="disableBirthday"
            v-model="birthday"
            type="date"
          />
          <output v-if="disableBirthday" class="date-editor">
            {{ birthday }}
          </output>
        </div>
      </Block>
      <Editor
        v-model="facebook"
        editorClass="editor"
        class="editor-wrapper relative"
        type="passportAccountEditor"
        :disable="disableFacebook"
        placeholder="Facebook"
      ></Editor>
      <Block type="editorWrapper" class="editor-wrapper">
        <div class="editor relative">
          <div class="div-label">
            <div class="selector-wrapper">
              <select
                class="area-selector"
                id="cityCode"
                v-if="!disable_phone_code"
                :disabled="disable_phone_code"
                v-model="phone_code"
              >
                <option value="no" disabled selected>
                  {{ accountLanguages.countryCode }}
                </option>
                <option value="60">Malaysia +60</option>
                <option value="65">Singapore +65</option>
                <option value="63">Philippines +63</option>
                <option value="62">Indonesia +62</option>
                <option value="66">Thailand +66</option>
                <option value="84">Vietnam +84</option>
                <option value="86">China +86</option>
                <option value="886">Taiwan +886</option>
                <option value="852">Hong Kong +852</option>
                <option value="853">Macau +853</option>
                <option value="61">Australia +61</option>
                <option value="81">Japan +81</option>
                <option value="1">United States +1</option>
                <option value="82">South Korea +82</option>
                <option value="856">Laos +856</option>
                <option value="64">New Zealand +64</option>
                <option value="966">Saudi Arabia +966</option>
                <option value="855">Cambodia +855</option>
                <option value="971">United Arab Emirates +971</option>
                <option value="0">Other</option>
              </select>
              <output v-if="disable_phone_code" class="area-selector">
                {{ phoneCodeMap[phone_code] }}
              </output>
              <i class="area-select-icon"></i>
            </div>
            <input
              type="tel"
              class="editor"
              v-if="!disablePhone"
              :disabled="disablePhone"
              v-model="phone"
              v-bind:placeholder="accountLanguages.phone"
            />
            <output v-if="disablePhone" class="editor">{{ phone }}</output>
          </div>
        </div>
      </Block>
      <Editor
        v-model.trim="email"
        editorClass="editor"
        class="editor-wrapper relative"
        type="passportAccountEditor"
        :disable="disableEmail"
        :placeholder="accountLanguages.enterEmail.trim()"
      ></Editor>
      <!-- 2022.04.15 由于不符合韩国法律要求，所以去掉身份证护照输入，isKr为1时为韩国，否则为0 -->
      <!-- 2022.07.05 海外隐私法规不允许收集，所有游戏去除身份证护照输入 -->
      <!-- <Block type="editorWrapper" class="editor-wrapper" v-if="+isKr === 0">
        <div class="editor relative">
          <div class="div-label">
            <div class="selector-wrapper">
              <select
                class="area-selector"
                v-if="!disableId_card_country"
                :disabled="disableId_card_country"
                v-model="id_card_country"
              >
                <option value="0" disabled selected>
                  {{ accountLanguages.region }}
                </option>
                <option value="MY">Malaysia</option>
                <option value="SG">Singapore</option>
                <option value="PH">Philippines</option>
                <option value="RI">Indonesia</option>
                <option value="TH">Thailand</option>
                <option value="VN">Vietnam</option>
                <option value="CN">China</option>
                <option value="TW">Taiwan</option>
                <option value="HK">Hong Kong</option>
                <option value="MO">Macau</option>
                <option value="AU">Australia</option>
                <option value="JP">Japan</option>
                <option value="US">United States</option>
                <option value="KR">South Korea</option>
                <option value="LA">Laos</option>
                <option value="SA">New Zealand</option>
                <option value="MY">Saudi Arabia</option>
                <option value="KH">Cambodia</option>
                <option value="AE">United Arab Emirates</option>
                <option value="ZZ">Other</option>
              </select>
              <output v-if="disableId_card_country" class="area-selector">
                {{ areaMap[id_card_country] }}
              </output>
              <i class="area-select-icon"></i>
            </div>
            <input
              class="editor"
              v-if="!disableId_card_number"
              :disabled="disableId_card_number"
              v-model="id_card_number"
              v-bind:placeholder="accountLanguages.ID"
            />
            <output v-if="disableId_card_number" class="area-selector">
              {{ id_card_number }}
            </output>
          </div>
        </div>
      </Block> -->
      <!-- <Agreements v-if="!disableSubmit" v-on:changeAgreeTerms="selectTerm"></Agreements> -->
      <Block
        type="editorWrapper"
        class="agree-wrapper"
        :class="$platformClass"
        v-if="!disableSubmit"
      >
        <Button
          data-asyncbtn
          class="btn account-setting-submit"
          type="lightfill"
          @click="setProfile"
        >
          <Icon type="commonBtnLeft"></Icon>
          <Icon type="commonBtnRight"></Icon>
          {{ accountLanguages.submit }}
        </Button>
      </Block>
    </form>
    <form id="changePasswordForm" :class="$platformClass" v-if="isVgm">
      <Editor
        v-model="realName"
        editorClass="editor"
        class="editor-wrapper relative"
        type="passportAccountEditor"
        :disable="disableRealName"
        :placeholder="accountLanguages.realName"
      ></Editor>
      <Block type="editorWrapper" class="editor-wrapper">
        <div class="editor relative">
          <span class="common-title">{{ accountLanguages.gender }}</span>
          <div class="sex-box" id="J_sex_box">
            <i
              class="sex-icon splite"
              v-bind:class="{ male: sex == MALE, female: sex == FEMALE }"
            ></i>
            <button
              type="button"
              :disabled="disableSex"
              @click="switchSex"
              class="sex_radios splite"
            ></button>
            <div class="sex-box-text" id="J_sex_box_text">{{ sexText }}</div>
          </div>
        </div>
      </Block>
      <Block type="editorWrapper" class="editor-wrapper">
        <div class="editor relative div-label">
          <span class="common-title span-label">
            {{ accountLanguages.birthday }}
          </span>
          <input
            class="date-editor"
            v-if="!disableBirthday"
            :disabled="disableBirthday"
            v-model="birthday"
            type="date"
          />
          <output v-if="disableBirthday" class="date-editor">
            {{ birthday }}
          </output>
        </div>
      </Block>
      <Editor
        v-model.trim="phone"
        editorClass="editor"
        class="editor-wrapper relative"
        type="passportAccountEditor"
        :disable="disablePhone"
        :placeholder="accountLanguages.phone"
      ></Editor>
      <Editor
        v-model="facebook"
        editorClass="editor"
        class="editor-wrapper relative"
        type="passportAccountEditor"
        :disable="disableFacebook"
        placeholder="Facebook"
      ></Editor>
      <Editor
        v-model.trim="id_card_number"
        editorClass="editor"
        class="editor-wrapper relative"
        type="passportAccountEditor"
        :disable="disableId_card_number"
        placeholder="số CMND/hộ chiếu/căn cước"
      ></Editor>
      <Block type="editorWrapper" class="editor-wrapper">
        <div class="editor relative div-label">
          <span class="common-title span-label">Ngày cấp</span>
          <output v-if="disableId_card_issue_date" class="date-editor">
            {{ id_card_issue_date }}
          </output>
          <input
            v-if="!disableId_card_issue_date"
            class="date-editor"
            v-model="id_card_issue_date"
            type="date"
          />
        </div>
      </Block>
      <Editor
        v-model.trim="id_card_issue_region"
        editorClass="editor"
        class="editor-wrapper relative"
        type="passportAccountEditor"
        :disable="disableId_card_issue_region"
        placeholder="Vui lòng nhập địa chỉ Nơi Cấp chính xác"
      ></Editor>
      <Editor
        v-model.trim="email"
        editorClass="editor"
        class="editor-wrapper relative"
        type="passportAccountEditor"
        :disable="disableEmail"
        placeholder="Vui lòng nhập địa chỉ E-mail chính xác"
      ></Editor>
      <Editor
        v-model.trim="address"
        editorClass="editor"
        class="editor-wrapper relative"
        type="passportAccountEditor"
        :disable="disableAddress"
        placeholder="Vui lòng nhập địa chỉ cư trú chính xác"
      ></Editor>
      <!-- <Agreements v-if="!disableSubmit" v-on:changeAgreeTerms="selectTerm"></Agreements> -->
      <Block
        type="editorWrapper"
        class="agree-wrapper"
        :class="$platformClass"
        v-if="!disableSubmit"
      >
        <Button
          refs="ddd"
          data-asyncbtn
          class="btn account-setting-submit"
          type="lightfill"
          @click="doSetProfileVgm"
        >
          <Icon type="commonBtnLeft"></Icon>
          <Icon type="commonBtnRight"></Icon>
          {{ accountLanguages.submit }} {{ terms }}
        </Button>
      </Block>
    </form>
    <transition name="fade">
      <Dialog v-show="showDialog"></Dialog>
    </transition>
    <transition name="fade">
      <Tost v-show="showTost"></Tost>
    </transition>
    <PopupWindow
      @onCancel="showPopup = false"
      @onConfirm="showPopup = false"
      type="tips"
      v-if="showPopup"
      :languages="accountLanguages"
      :content="errTips"
    ></PopupWindow>
  </Block>
</template>
<script>
import {
  LOAD_EXTEND_INFO,
  SET_USR_EXT_INFO,
  SET_USR_EXT_INFO_VGM,
} from '../../store/passport/accountSetting';
import AccountSettingMixins from '../../mixins/AccountSetting';
import { CLOSE_EVENT } from '../../components/Tips';
import { SHOW_TIPS_MSG } from '../../store/dialog';
import { EventBus } from '../../utiles';
// import Agreements from "../../components/passport/Agreements";
import ProfileHeader from '../../components/passport/ProfileHeader';
import commonHeader from '@/resource/components/support/header';
import globalConfig from '../../utiles/globalConfig';
const SUBMIT_PROFILE = 'submitProfile';
const MALE = 0;
export default {
  data() {
    return {
      isKr: '',
      isVgm: '',
      id_card_issue_date: '',
      id_card_issue_region: '',
      address: '',
      realName: '',
      birthday: '',
      email: '',
      id_card_country: '',
      id_card_number: '',
      phone: '',
      phone_code: '',
      sex: MALE,
      MALE: 0,
      FEMALE: 1,
      terms: true,
      facebook: '',
      disableRealName: false,
      disableBirthday: false,
      disable_phone_code: false,
      disableId_card_country: false,
      disableId_card_number: false,
      disablePhone: false,
      disableSex: false,
      disableTerms: false,
      disableFacebook: false,
      disableEmail: false,
      disableId_card_issue_region: false,
      disableId_card_issue_date: false,
      disableAddress: false,
      completion: 0,
      sexText: '',
      disableSubmit: false,
      areaMap: {
        MY: 'Malaysia',
        SG: 'Singapore',
        PH: 'Philippines',
        RI: 'Indonesia',
        TH: 'Thailand',
        VN: 'Vietnam',
        CN: 'China',
        TW: 'Taiwan',
        HK: 'Hong Kong',
        MO: 'Macau',
        AU: 'Australia',
        JP: 'Japan',
        US: 'United States',
        KR: 'South Korea',
        LA: 'Laos',
        NZ: 'New Zealand',
        SA: 'Saudi Arabia',
        KH: 'Cambodia',
        AE: 'United Arab Emirates',
        ZZ: 'Other',
      },
      phoneCodeMap: {
        60: 'Malaysia +60',
        65: 'Singapore +65',
        63: 'Philippines +63',
        62: 'Indonesia +62',
        66: 'Thailand +66',
        84: 'Vietnam +84',
        86: 'China +86',
        886: 'Taiwan +886',
        852: 'Hong Kong +852',
        853: 'Macau +853',
        61: 'Australia +61',
        81: 'Japan +81',
        1: 'United States +1',
        82: 'South Korea +82',
        856: 'Laos +856',
        64: 'New Zealand +64',
        966: 'Saudi Arabia +966',
        855: 'Cambodia +855',
        971: 'United Arab Emirates +971',
        0: 'Other',
      },
      isSDK: false,
    };
  },
  created() {
    this.loadExtendInfo();
    EventBus.$on(CLOSE_EVENT, eventType => {
      if (SUBMIT_PROFILE == eventType) {
        this.doSetProfile();
      }
    });
    this.selectTerm(true);
    let hasSdkToken = !!globalConfig.getHrefParam('sdkToken');
    let isWeb = +globalConfig.getHrefParam('web') === 1;
    let isH5 = +globalConfig.getHrefParam('h5') === 1;
    this.isSDK = hasSdkToken || (isWeb && isH5);
  },
  computed: {
    completionLeft() {
      return this.completion + '%';
    },
    logined() {
      if (this.$store.state.account.logined) {
        this.loadExtendInfo();
      }
      return this.$store.state.account.logined;
    },
  },

  watch: {
    logined(newVal) {
      if (newVal) {
        this.loadExtendInfo();
      }
    },
    sex(newVal) {
      this.sexText =
        newVal === MALE ? this.languages.male : this.languages.female;
    },
  },
  components: { ProfileHeader, commonHeader },
  mixins: [AccountSettingMixins],
  methods: {
    loadExtendInfo() {
      this.$store
        .dispatch(LOAD_EXTEND_INFO, {
          appLanguage: this.accountLang,
          language: this.accountLang,
          notNeedInitLanguage: true,
        })
        .then(extendInfo => {
          this.isKr = extendInfo.isKr;
          this.isVgm = extendInfo.isVgm;
          this.id_card_issue_date = extendInfo.id_card_issue_date;
          this.id_card_issue_region = extendInfo.id_card_issue_region;
          this.address = extendInfo.address;
          this.email = extendInfo.email;
          this.realName = extendInfo.realName;
          this.birthday = extendInfo.birthday;
          this.id_card_country = extendInfo.id_card_country || '0';
          this.id_card_number = extendInfo.id_card_number;
          this.phone = extendInfo.phone;
          this.phone_code = extendInfo.phoneCode || 'no';
          this.sex = extendInfo.sex > 0 ? extendInfo.sex - 1 : extendInfo.sex;
          this.terms = true;
          this.facebook = extendInfo.facebook;
          this.completion = extendInfo.completion;
          this.disableRealName = this.realName != '';
          this.disableBirthday = this.birthday != '';
          this.disable_phone_code =
            this.phone_code != '' && this.phone_code != 'no';
          this.disableId_card_country =
            this.id_card_country != '' && this.id_card_country != '0';
          this.disableId_card_number = this.id_card_number != '';
          this.disablePhone = this.phone != '';
          this.disableSex = extendInfo.sex !== '' && extendInfo.sex != 0;
          this.disableFacebook = this.facebook != '';
          this.disableEmail = this.email != '';
          this.disableId_card_issue_region = this.id_card_issue_region != '';
          this.disableId_card_issue_date = this.id_card_issue_date != '';
          this.disableAddress = this.address != '';
          if (!this.isVgm) {
            this.disableSubmit =
              this.disableRealName &&
              this.disableBirthday &&
              this.disableId_card_country &&
              this.disableId_card_number &&
              this.disablePhone &&
              this.disableSex &&
              this.disableFacebook &&
              this.disableEmail &&
              this.disable_phone_code;
          } else {
            this.disable_phone_code = true;
            this.disableSubmit =
              this.disableRealName &&
              this.disableBirthday &&
              this.disableId_card_number &&
              this.disablePhone &&
              this.disableSex &&
              this.disableFacebook &&
              this.disableId_card_issue_region &&
              this.disableEmail &&
              this.disableId_card_issue_date &&
              this.disableAddress;
          }
        });
    },
    switchSex() {
      this.sex = (this.sex + 1) % 2;
    },
    setProfile() {
      var tips = this.languages.canotModifyTips;
      this.$store.dispatch(SHOW_TIPS_MSG, {
        message: tips,
        tipsConfirmCallback: SUBMIT_PROFILE,
      });
    },

    doSetProfile() {
      var params = {
        terms: this.terms,
      };
      if (this.birthday != undefined && this.birthday !== '') {
        params['birthday'] = this.birthday;
      }
      if (
        this.id_card_country != undefined &&
        this.id_card_country !== '' &&
        this.id_card_number !== '' &&
        !/\*{3}/.test(this.id_card_number)
      ) {
        params['id_card_country'] = this.id_card_country;
      }

      if (this.id_card_number != '' && !/\*{3}/.test(this.id_card_number)) {
        params['id_card_number'] = this.id_card_number;
      }

      if (!this.disableSex) {
        params['sex'] = this.sex + 1;
      }

      if (this.realName != '' && !/\*{3}/.test(this.realName)) {
        params['real_name'] = this.realName;
      }
      if (this.phone != '' && !/\*{3}/.test(this.phone)) {
        params['phone'] = this.phone;
      }
      if (this.phone_code == 'no') {
        params['phone_code'] = '';
      } else {
        params['phone_code'] = this.phone_code;
      }
      if (this.facebook != '' && !this.disableFacebook) {
        params['fb_account'] = this.facebook;
      }
      if (this.email != '' && !this.disableEmail) {
        params['email'] = this.email;
      }

      this.$store
        .dispatch(SET_USR_EXT_INFO, {
          ...params,
          appLanguage: this.accountLang,
          language: this.accountLang,
          notNeedInitLanguage: true,
        })
        .then(extendInfo => {
          this.realName = extendInfo.realName;
          this.birthday = extendInfo.birthday;
          this.id_card_country = extendInfo.id_card_country || '0';
          this.id_card_number = extendInfo.id_card_number;
          this.phone = extendInfo.phone;
          this.sex = parseInt(extendInfo.sex) - 1;
          this.terms = true;
          this.facebook = extendInfo.facebook;
          this.completion = extendInfo.completion;
          this.disableRealName = this.realName != '';
          this.disableBirthday = this.birthday != '';
          this.disableId_card_country =
            this.id_card_country != '' && this.id_card_country != '0';
          this.disableId_card_number = this.id_card_number != '';
          this.disablePhone = this.phone != '';
          this.disableSex = extendInfo.sex !== '' && extendInfo.sex !== '0';
          this.disableFacebook = this.facebook != '';
          this.disableEmail = this.email != '';
          this.disableSubmit =
            this.disableRealName &&
            this.disableBirthday &&
            this.disableId_card_country & this.disableId_card_number &&
            this.disablePhone &&
            this.disableSex &&
            this.disableFacebook &&
            this.disableEmail;
        })
        .catch(err => {
          this.showErrorTips(err.message);
        });
    },
    doSetProfileVgm() {
      const params = {
        terms: this.terms,
      };
      if (!this.disableRealName) {
        params['real_name'] = this.realName;
      }
      if (!this.disableBirthday) {
        params['birthday'] = this.birthday;
      }
      if (!this.disableId_card_country) {
        params['id_card_country'] = 'VN';
      }
      if (!this.disableSex) {
        params['sex'] = this.sex + 1;
      }
      if (!this.disableId_card_number) {
        params['id_card_number'] = this.id_card_number;
      }
      if (!this.disableId_card_issue_date) {
        params['id_card_issue_date'] = this.id_card_issue_date;
      }
      if (!this.disableId_card_issue_region) {
        params['id_card_issue_region'] = this.id_card_issue_region;
      }
      if (!this.disableFacebook) {
        params['fb_account'] = this.fb_account;
      }
      if (!this.disablePhone) {
        params['phone'] = this.phone;
        params['phone_code'] = '84';
      }
      if (!this.disableEmail) {
        params['email'] = this.email;
      }
      if (!this.disableAddress) {
        params['address'] = this.address;
      }
      this.$store
        .dispatch(SET_USR_EXT_INFO_VGM, {
          ...params,
          appLanguage: this.accountLang,
          language: this.accountLang,
          notNeedInitLanguage: true,
        })
        .then(extendInfo => {
          this.realName = extendInfo.realName;
          this.birthday = extendInfo.birthday;
          this.id_card_country = extendInfo.id_card_country || '0';
          this.id_card_number = extendInfo.id_card_number;
          this.phone = extendInfo.phone;
          this.sex = parseInt(extendInfo.sex) - 1;
          this.terms = true;
          this.facebook = extendInfo.facebook;
          this.completion = extendInfo.completion;
          this.disableRealName = this.realName != '';
          this.disableBirthday = this.birthday != '';
          this.disableId_card_country =
            this.id_card_country != '' && this.id_card_country != '0';
          this.disableId_card_number = this.id_card_number != '';
          this.disablePhone = this.phone != '';
          this.disableSex = extendInfo.sex !== '' && extendInfo.sex !== '0';
          this.disableFacebook = this.facebook != '';
          this.disableEmail = this.email != '';
          this.disableId_card_issue_region = this.id_card_issue_region != '';
          this.disableId_card_issue_date = this.id_card_issue_date != '';
          this.disableAddress = this.address != '';
          this.disableSubmit =
            this.disableRealName &&
            this.disableBirthday &&
            this.disableId_card_number &&
            this.disablePhone &&
            this.disableSex &&
            this.disableFacebook &&
            this.disableId_card_issue_region &&
            this.disableEmail &&
            this.disableId_card_issue_date &&
            this.disableAddress;
        })
        .catch(err => {
          this.showErrorTips(err.message);
        });
    },
  },
};
</script>
